import styled from"@emotion/styled";import{Col,FlexLayout,mediaQuery}from"@wp/src/components/common/grid";import IconContainer from"@wp/src/components/common/IconContainer";import Divider from"@wp/src/components/common/divider";import{InfoTooltip}from"@wp/src/components/common/tooltip";import{Body1W500Neutral800,H5W500Neutral900}from"@wp/src/components/common/atoms";import{Card}from"@wp/src/components/common/card";export const TotalNetWorthContainer=styled(Card)`
  margin-top: 16px;

  ${mediaQuery({width:["100%","100%","100%","100%","1160px","1264px"],padding:["0px","0px","0px","24px"]})}

  .ant-card-body {
    ${mediaQuery({padding:["16px","16px","24px"]})}
  }
`;export const NetworthContentContainer=styled(FlexLayout)`
  & > div:first-of-type {
    flex-grow: 1;

    ${mediaQuery({flexBasis:["100%","100%","65%","70%"]})}
  }

  & > div:last-child {
    ${mediaQuery({flexBasis:["100%","100%","30%","25%"]})}
  }
`;export const TotalNetWorthLabel=styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  color: ${props=>props.theme.colors.neutral600};
`;export const TotalNetworthValueContainer=styled.div`
  font-style: normal;
  font-weight: 500;

  ${mediaQuery({fontSize:["28px","28px","28px","32px","36px"],lineHeight:["40px","40px","48px","48px","60px","60px"]})}

  color: ${props=>props.theme.colors.neutral900};
`;export const NetworthContainerFooter=styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 8px;
`;export const FooterPeopleInfo=styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;

  color: ${props=>props.theme.colors.neutral500};
`;export const FooterSupportInfo=styled.div`
  &,
  > a {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
  }

  color: ${props=>props.theme.colors.neutral600};
`;export const NetworthListContainer=styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  margin: 16px 0;

  ${mediaQuery({maxWidth:["100%","100%","100%","100%","924px"]})};
`;export const NetworthItemWrapper=styled.div`
  display: flex;
  flex-direction: column;
`;export const NetworthItemMainContainer=styled.div`
  padding: 16px;
  border: 1px solid ${props=>props.theme.colors.neutral300};
  box-sizing: border-box;
  border-bottom-color: ${props=>props.isDetailedSectionAdded?"transparent":props.theme.colors.neutral400};
  border-radius: ${props=>props.isDetailedSectionAdded?"8px 8px 0px 0px":"8px"};
`;export const NetworthItemContainer=styled.div`
  display: flex;
  justify-content: space-between;
  background: ${props=>props.theme.colors.white};
  flex-wrap: nowrap;
  text-align: left;
  align-items: center;
`;export const NetWorthPrimaryWrapper=styled.div`
  display: flex;
  flex: 1;
`;export const NetworthItemIconContainer=styled.div`
  text-align: center;
  display: flex;
  align-items: center;
`;export const NetworthItemPrimaryContent=styled(Col)`
  margin-left: 16px;
`;export const NetworthItemLabel=styled(H5W500Neutral900)``;export const NetworthItemAmount=styled(Body1W500Neutral800)``;export const NetworthItemDescription=styled.div`
  font-style: normal;
  font-weight: normal;
  line-height: 20px;
  font-size: 12px;

  text-align: left;
  color: ${props=>props.theme.colors.neutral500};
`;export const NetworthIcon=styled(IconContainer)`
  width: 40px;
  height: 40px;
`;export const TotalNetworthHeader=styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  ${mediaQuery({flexWrap:["wrap","wrap","nowrap"],columnGap:["20px","20px",0]})}
`;export const TotalNetworthItem=styled.div`
  margin-left: auto;
  flex-grow: 2;
`;export const RightBarDivider=styled(Divider)`
  height: 100%;
`;export const EnteredNetworthActionTooltip=styled(InfoTooltip)`
  min-width: 196px;
  width: 100%;
`;export const NetworthNavigationActionsContainer=styled(FlexLayout)`
  ${mediaQuery({flexDirection:["column","row-reverse"],justifyContent:["stretch","flex-end"],alignItems:["stretch","center"],alignContent:["stretch","center"]})}

  & > * {
    // Targeting all children to handle row-reverse
    ${mediaQuery({marginRight:[0,"16px"]})}

    &:not(:last-child) {
      ${mediaQuery({marginBottom:["16px",0]})}
    }
  }

  .ant-btn-link {
    font-weight: 500;
  }
`;export const DetailedNetworthSectionContainer=styled.div`
  border: 1px solid ${props=>props.theme.colors.neutral300};
  box-sizing: border-box;
  border-radius: 0 0 8px 8px;
  overflow: auto;
`;